import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_ADMIN_URL;

export const submitContactForm = async (formData) => {
  const response = await axios.post(`${BASE_URL}/contact-us`, formData);
  return response.data;
};